"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ColumnChart = void 0;
var React = _interopRequireWildcard(require("react"));
var _highcharts = _interopRequireDefault(require("highcharts"));
var _highchartsReactOfficial = _interopRequireDefault(require("highcharts-react-official"));
var _charts = require("../../../utils/charts");
var _classify = _interopRequireDefault(require("../../../utils/classify"));
var _ChartWrapper = require("../ChartWrapper");
var _ColumnChartModule = _interopRequireDefault(require("./ColumnChart.module.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

//$FlowFixMe[untyped-import]

//$FlowFixMe[untyped-import]

const ColumnChart = _ref => {
  let {
    isLoading,
    classNames,
    cardTitle,
    customExportOptions,
    series,
    drilldown,
    headerActions,
    hasEmptyData,
    emptyText,
    ...userOptions
  } = _ref;
  const chartRef = /*#__PURE__*/React.createRef();
  const columnChartSeries = series.map((seriesItem, index) => ({
    ...seriesItem,
    name: seriesItem.name,
    data: seriesItem.data,
    color: (0, _charts.getDataVizColor)(index),
    pointWidth: _charts.columnPlotWidth
  }));
  const addColorToDrilldownSeries = series => series?.map(seriesItem => ({
    ...seriesItem,
    data: seriesItem.data.map((dataItem, index) => ({
      ...dataItem,
      color: (0, _charts.getDataVizColor)(index),
      pointWidth: _charts.columnPlotWidth
    }))
  }));
  const columnDrilldown = drilldown ? {
    ...drilldown,
    series: addColorToDrilldownSeries(drilldown.series),
    breadcrumbs: {
      floating: false
    }
  } : {};
  const defaultColumnChartOptions = (0, _charts.getColumnChartOptions)();

  //$FlowFixMe[cannot-spread-inexact]
  const chartOptions = (0, _charts.mergeChartUserOptions)(defaultColumnChartOptions, {
    series: columnChartSeries,
    drilldown: columnDrilldown,
    ...userOptions
  });
  const {
    highChart,
    ...wrapperClassNames
  } = classNames || {};
  return /*#__PURE__*/React.createElement(_ChartWrapper.ChartWrapper, {
    isLoading: isLoading,
    title: cardTitle,
    ref: chartRef,
    classNames: wrapperClassNames,
    customExportOptions: customExportOptions,
    headerActions: headerActions,
    hasEmptyData: hasEmptyData,
    emptyText: emptyText
  }, /*#__PURE__*/React.createElement(_highchartsReactOfficial.default, {
    highcharts: _highcharts.default,
    containerProps: {
      className: (0, _classify.default)(_ColumnChartModule.default.columnChartContainer, highChart)
    },
    ref: chartRef,
    options: chartOptions
  }));
};
exports.ColumnChart = ColumnChart;